import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { OracleStorageServiceInterface } from '@interfaces/oracle-storage.interface';
import { OracleStorageActionModel } from '@models/common/oracle-storage-action.model';
import { Observable, of } from 'rxjs';
import { environment } from '@environments/environment';
import { map, tap, retry } from 'rxjs/operators';
import { TOKEN_GRAPH_API } from '../constants/ad.constants';

@Injectable({
  providedIn: 'root'
})
export class OracleStorageService<T> implements OracleStorageServiceInterface<T> {

  constructor(private httpClient: HttpClient) { }

  getToken$(isExpired: boolean): Observable<string> {
    const token: string = localStorage.getItem(TOKEN_GRAPH_API);
    if (!isExpired && token) return of(token)
    return this.httpClient
      .get(environment.graphApiToken)
      .pipe(
        tap(token => console.log(token)),
        map(data => data["data"]),
        tap(token => localStorage.setItem(TOKEN_GRAPH_API, token))
      )
  }

  create$(action: OracleStorageActionModel<T>): Observable<T> {
    return this.httpClient
      .post(`${environment.apiUrl}${action.queryParams}`, action.payload)
      .pipe(
        retry(3),
        map(data => data as T)
      )
  }


  search$(action: OracleStorageActionModel<T>): Observable<T[]> {
    return this.httpClient
      .get(`${environment.apiUrl}${action.queryParams}`)
      .pipe(
        retry(3),
        map(data => data as T[]),
      )
  }

  searchOne$(action: OracleStorageActionModel<T>): Observable<T[]> {
    let params = new HttpParams();
    //let IdU = action.payload.IdU;
    //params = params.append('id', IdU);
    return this.httpClient
      .get(`${environment.apiUrl}${action.queryParams}`)
      .pipe(
        retry(3),
        map(data => data as T[]),
      )
  }

  update$(action: OracleStorageActionModel<T>): Observable<T> {
    return this.httpClient
      .post(`${environment.apiUrl}${action.queryParams}`, action.payload)
      .pipe(
        retry(3),
        map(data => action.payload as T)
      )
  }


  delete$(action: OracleStorageActionModel<T>): Observable<T> {
    return this.httpClient
      .delete(`${environment.apiUrl}${action.queryParams}`, action.payload)
      .pipe(
        retry(3),
        map(data => action.payload as T)
      )
  }

  createSecond$(action: OracleStorageActionModel<T>): Observable<T> {
    let url = "http://taumas.eafit.edu.co"+ environment.BASE_REF +"/apifirmasdigitales/api/";
    return this.httpClient
    .get(`${environment.apiUrl}${action.queryParams}`)
      .pipe(
        retry(3),
        map(data => data as T)
      )
  }

  createGeneric$(action: OracleStorageActionModel<T[]>): Observable<T[]> {
    return this.httpClient
      .get(`${environment.apiUrl}${action.queryParams}`)
      .pipe(
        retry(3),
        map(data => data as T[]),
      )
  }

  loggerErrorHttp(error: HttpErrorResponse): void {
  }

}
